module.exports = __webpack_public_path__ + "img/修饰词.f3116df1.svg";